import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useDeleteUser = (onClose) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.DELETE_USER],
    (id) => UserService.deleteUser(id),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_USER_LIST);
        onClose();
        toast.success("User deleted successfully");
      },
      onError: (error) => {
        toast.error(error.response.data.message);
      },
    }
  );
};

export default useDeleteUser;
